import { types, flow, getRoot } from "mobx-state-tree";

export default types
  .model("CrTypesModel", {
    id: types.optional(types.number, 0),
    name: types.optional(types.string, ""),
  })
  .views((self) => ({}));
